<template>
  <div class="Android-container">
    <header>
      <span class="title">Android版本更新</span>
      <div class="right">
        <el-button type="primary" @click="addDetail">新 增</el-button>
      </div>
    </header>
    <el-table ref='multipleTable' :data='tableList' tooltip-effect='dark' style='width: 100%;' class="el-table-01" @row-click="rowClick">
      <el-table-column prop='v_code' label='版本号' width="200"></el-table-column>
      <el-table-column label='更新时间' width="220">
        <template slot-scope='scope'>{{ scope.row.v_date | formatDate('yyyy-MM-dd HH:mm') }}</template>
      </el-table-column>
      <el-table-column label='是否强制更新' width="200">
        <template slot-scope='scope'>{{ scope.row.v_must === '0' ? '否' : '是' }}</template>
      </el-table-column>
      <el-table-column prop='v_content' label='更新内容' min-width="240"></el-table-column>
    </el-table>

    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box">
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note">删除后不可恢复</div>
      <div class="prompt">你确定要删除吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="delVersion">确 定</el-button>
      </span>
    </el-dialog>

    <div class="mask n2" v-if="dialogAppDetail" @click="dialogAppDetail = false"></div>
    <transition name="slide">
      <el-container class="data-detail-wrip" v-if="dialogAppDetail">
        <header>
          <span>{{versionDetail.v_code}}</span>
          <i class="iconfont icon-close" @click="dialogAppDetail = false"></i>
        </header>
        <div class="tab-box">
          <div class="tab-item active"><span>版本资料</span></div>
        </div>
        <div class="head">
          <span>基本信息</span>
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-arrow-down el-icon-more"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">删  除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="editDetail">编辑</el-button>
        </div>
        <div class="content">
          <el-collapse v-model="activeNames">
            <el-collapse-item name="1">
              <template slot="title">
                <i class="iconfont icon-zhankai"></i>
                基本信息
              </template>
              <div class="form">
                <div class="item single">
                  <span class="title">版本号</span>
                  <div class="item-content">{{versionDetail.v_code}}</div>
                </div>
                <div class="item single">
                  <span class="title">更新时间</span>
                  <div class="item-content">{{versionDetail.v_date | formatDate('yyyy-MM-dd HH:mm')}}</div>
                </div>
                <div class="item single">
                  <span class="title">是否强制更新</span>
                  <div class="item-content">{{versionDetail.v_must === '1' ? '是':'否'}}</div>
                </div>
                <div class="item single">
                  <span class="title">备注</span>
                  <div class="item-content">{{versionDetail.v_content}}</div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="2">
              <template slot="title">
                <i class="iconfont icon-zhankai"></i>
                系统信息
              </template>
              <div class="form">
                <div class="item">
                  <span class="title">创建人</span>
                  <div class="item-content">{{versionDetail.create_by}}</div>
                </div>
                <div class="item">
                  <span class="title">创建时间</span>
                  <div class="item-content">{{versionDetail.create_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                </div>
                <div class="item">
                  <span class="title">修改人</span>
                  <div class="item-content">{{versionDetail.modify_by}}</div>
                </div>
                <div class="item">
                  <span class="title">修改时间</span>
                  <div class="item-content">{{versionDetail.modify_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-container>
    </transition>

    <div class="mask" v-if="dialogAddDetail" @click="dialogAddDetail = false"></div>
    <transition name="slide">
      <el-container class="add-dialog" v-if="dialogAddDetail">
        <header>Android版本更新
          <i class="iconfont icon-close" @click="dialogAddDetail = false"></i>
        </header>
        <div class="content">
          <div class="banner">
            <!-- <div class="h1">账号管理</div>
            <div class="h2">管理中央控制台的所有登录账号</div> -->
          </div>
          <div class="form">
            <div class="form-header">基本信息</div>
            <div class="form-content">
              <div class="form-item single">
                <span class="item-title"><span class="need">*</span>版本号</span>
                <div class="item-right">
                  <el-input v-model="v_code" placeholder="请输入(必填)" size="medium"></el-input>
                </div>
                <div class="err" v-if="err_c"><i class="el-icon-warning"></i>{{err_c}}</div>
              </div>
              <div class="form-item single">
                <span class="item-title">更新时间</span>
                <div class="item-right">
                  <el-date-picker v-model="v_date" type="date" placeholder="选择日期" value-format="timestamp"></el-date-picker>
                </div>
                <div class="err" v-if="err_d"><i class="el-icon-warning"></i>{{err_d}}</div>
              </div>
              <div class="form-item single">
                <span class="item-title item-title2"><span>是否</span><span>强制更新</span></span>
                <div class="item-right" style="line-height: 40px;">
                  <el-checkbox v-model="v_must" style="line-height: 1;"> </el-checkbox>
                </div>
              </div>
              <div class="form-item single">
                <span class="item-title">备注</span>
                <div class="item-right">
                  <el-input type="textarea" v-model="v_content" placeholder="请输入" size="medium" :rows="3" resize="none" :maxlength="100"></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <el-button @click="dialogAddDetail = false">取 消</el-button>
          <el-button type="primary" @click="dialogSave">保 存</el-button>
        </footer>
      </el-container>
    </transition>

  </div>
</template>
<script>
import {HTTPServer} from '@/common/js/ajax.js'
export default {
  data () {
    return {
      defaultMsg: '<b>Android版本更新</b>',
      funAuth: [],
      tableList: [],
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      disabled: true,
      dialogDelete: false,
      dialogAddDetail: false,
      dialogAppDetail: false,
      versionDetail: {},
      dialogStatus: false,
      dialogPwd: false,
      v_code: '',
      err_c: '',
      v_date: '',
      err_d: '',
      v_must: '',
      v_content: ''
    }
  },
  // mixins: [mixin],
  mounted () {
    this.getVersionList()
  },
  methods: {
    /** 获取列表 */
    getVersionList (id) {
      var jsondata = {}
      HTTPServer.getVersionList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        if (id) {
          res.map((item) => {
            if (item.id === id) {
              this.versionDetail = item
            }
          })
        }
      })
    },
    /** 新增用户 （弹窗） */
    addDetail () {
      this.v_code = 'V'
      this.v_date = (new Date()).getTime()
      this.v_must = false
      this.v_content = ''
      this.dialogAddDetail = true
    },
    /** 修改用户 （弹窗） */
    editDetail () {
      let data = JSON.parse(JSON.stringify(this.versionDetail))
      this.v_code = data.v_code
      this.v_date = data.v_date
      this.v_must = data.v_must === '1'
      this.v_content = data.v_content
      this.dialogAddDetail = true
    },
    /** 新增、编辑 */
    dialogSave () {
      this.err_c = ''
      if (!this.v_code) {
        this.err_c = '版本号不能为空'
        return
      }
      var jsondata = {'v_code': this.v_code, 'v_date': this.v_date, 'v_must': this.v_must ? 1 : 0, 'v_content': this.v_content}
      if (this.dialogAppDetail) {
        jsondata.id = this.versionDetail.id
        console.log(this.versionDetail, jsondata)
        HTTPServer.updateVersionInfo(jsondata, 'Loading').then((res) => {
          this.$message({
            showClose: true,
            message: '保存成功！',
            type: 'success'
          })
          this.dialogAddDetail = false
          this.getVersionList(jsondata.id)
        })
      } else {
        HTTPServer.saveVersionInfo(jsondata, 'Loading').then((res) => {
          this.$message({
            showClose: true,
            message: '保存成功！',
            type: 'success'
          })
          this.dialogAddDetail = false
          this.getVersionList()
        })
      }
    },
    /** 进入客户详情 */
    rowClick (row, event, column) {
      this.activeNames = ['1', '2']
      this.versionDetail = row
      this.dialogAppDetail = true
    },
    /** 详情 - 点击菜单项触发的事件回调 */
    handleCommand (command) {
      if (command === '1') {
        this.dialogDelete = true
      }
    },
    /** 删除 */
    delVersion () {
      HTTPServer.delVersionInfo({id: this.versionDetail.id}, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.getVersionList()
        this.dialogDelete = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/appversion/Android.vue